// extracted by mini-css-extract-plugin
export default {"iconContainer":"GeneralChipSelect_iconContainer__pVmwc","iconOpen":"GeneralChipSelect_iconOpen__STqV5"};